import { validateResponse } from "../../../../response.js";
import { authHeader, acceptJson } from "../../../../shared.js";
import { subscriptionListResponse } from "./specs.js";
const list = async (apiUrl, { customerId, accessToken }) => {
  return validateResponse(
    subscriptionListResponse,
    await fetch(`${apiUrl}/customers/customer/${encodeURIComponent(customerId)}/subscriptions`, {
      method: "GET",
      headers: {
        ...acceptJson,
        ...authHeader(accessToken)
      }
    })
  );
};
export {
  list
};
//# sourceMappingURL=list.js.map
